import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const Available = ({ onSync, syncing }: { onSync: () => void; syncing: boolean }) => {
  return (
    <>
      <Text.Header2>
        {i18n.t('payroll_integrations.incidences.datev_api.hiring.available.title')}
      </Text.Header2>
      <Box>{i18n.t('payroll_integrations.incidences.datev_api.hiring.available.message')}</Box>
      <Button onClick={onSync} disabled={syncing}>
        {i18n.t('payroll_integrations.incidences.datev_api.hiring.available.submit')}
      </Button>
    </>
  )
}

export default Available
